import { Checkbox, Form, InputNumber, Button, message } from "antd";
import Heading from "components/Heading/Heading";

import { useEffect } from "react";
import {
  useGetStoresSettingQuery,
  useUpdateStoresSettingMutation,
} from "../../../redux/Service/storesApi";

function StoresSettings() {
  const [form] = Form.useForm();

  const {
    data: configData,
    isLoading,
    isError,
  } = useGetStoresSettingQuery(undefined);

  const config = configData?.ResponseObject ?? {};

  const [updateSettings, { isLoading: isUpdating }] =
    useUpdateStoresSettingMutation();

  useEffect(() => {
    if (Object.keys(config).length) {
      form.setFieldsValue(config);
    }
  }, [config, form]);

  const onFinish = async (values: any) => {
    try {
      const response = await updateSettings(values).unwrap();
      if (response?.ResponseObject === true) {
        message.success("تم حفظ الإعدادات بنجاح");
      } else {
        message.error("حدث خطأ أثناء الحفظ");
      }
    } catch (error) {
      message.error("فشل الاتصال بالخادم");
    }
  };

  return (
    <>
      <Heading name="إعدادات المخازن" />
      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        initialValues={config}
      >
        <div className="grid grid-cols-1 xl:grid-cols-3 gap-6">
          <Form.Item name="StoreCost" label="تسعير المخزن">
            <InputNumber className="w-full" min={0} />
          </Form.Item>

          <Form.Item name="StoreTrans" label="تحويلات المخزن">
            <InputNumber className="w-full" min={0} />
          </Form.Item>

          <Form.Item
            name="StockCycel"
            label="دورة الجرد"
            tooltip="عدد الأيام أو الدورة الزمنية للجرد"
          >
            <InputNumber className="w-full" min={0} />
          </Form.Item>

          {/* Checkboxes */}
          <Form.Item name="IsUseAutoCategoryId" valuePropName="checked">
            <Checkbox>استخدام رقم تلقائي للفئة</Checkbox>
          </Form.Item>

          <Form.Item name="IsQtyOnly" valuePropName="checked">
            <Checkbox>استخدام الكميه فقط</Checkbox>
          </Form.Item>

          <Form.Item name="IsRepeatProd" valuePropName="checked">
            <Checkbox>السماح بتكرار المنتج</Checkbox>
          </Form.Item>

          <Form.Item name="IsUsePiceZero" valuePropName="checked">
            <Checkbox>السماح بسعر 0</Checkbox>
          </Form.Item>

          <Form.Item name="IsUseStoreInDet" valuePropName="checked">
            <Checkbox>تفاصيل المخزن الفرعية</Checkbox>
          </Form.Item>

          <Form.Item name="IsUseExpDate" valuePropName="checked">
            <Checkbox>تفعيل تاريخ الصلاحية</Checkbox>
          </Form.Item>

          <Form.Item name="IsUseColorSize" valuePropName="checked">
            <Checkbox>استخدام نظام المقاسات والالوان</Checkbox>
          </Form.Item>
        </div>

        <div className="text-center mt-5">
          <Button
            type="primary"
            htmlType="submit"
            loading={isLoading || isUpdating}
          >
            حفظ الإعدادات
          </Button>
        </div>
      </Form>
    </>
  );
}

export default StoresSettings;
